import React from "react";

import styles from "./TradingPanel.module.css";

interface Props {
  enabled: boolean;
  onToggle: () => void;
}

// Кнопка видна только пользователям с status.switch_time === true (см. TradingPanel).
export const SwitchTimeButton: React.FC<Props> = ({ enabled, onToggle }) => (
  <button
    type="button"
    className={`
      
      ${styles.switchTimeButton} ${enabled ? styles.switchTimeButtonActive : ""}`}
    onClick={onToggle}
  >
    Switch Time
  </button>
);
